export const HANDLE_GET_CUSTOM_LIST = "HANDLE_GET_CUSTOM_LIST"
export const HANDLE_CUSTOM_SCAN_EXPORT = "HANDLE_CUSTOM_SCAN_EXPORT";
export const HANDLE_CUSTOM_MEASUREMENT_UPDATE = "HANDLE_CUSTOM_MEASUREMENT_UPDATE";
export const HANDLE_CUSTOM_NOTES_UPDATE = "HANDLE_CUSTOM_NOTES_UPDATE"
export const HANDLE_DEBOUNCE_CUSTOM_NOTES_UPDATE = "HANDLE_DEBOUNCE_CUSTOM_NOTES_UPDATE"
export const HANDLE_DEBOUNCE_CUSTOM_MEASUREMENT_UPDATE = "HANDLE_DEBOUNCE_CUSTOM_MEASUREMENT_UPDATE"